import { FC } from 'react';
import { Box, Grid, Stack, Typography, useTheme } from '@mui/material';
import ChipSocialMediaObject from 'src/components/ChipSocialMediaObject';
import { ITempInputKeywordOrHashtag } from 'src/features/objectManagement';
import { IObjectInput } from 'src/models/objectManagement';

interface Props {
  title: string;
  information: string;
  objectList: Array<ITempInputKeywordOrHashtag> | Array<IObjectInput>;
  onRemove: (id: string) => void;
}

const InputCardSocialProfile: FC<Props> = ({
  title,
  information,
  objectList,
  onRemove
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        background: '#FFFFFF',
        border: '0.5px solid rgba(5, 28, 38, 0.2)',
        boxSizing: 'border-box',
        borderRadius: '6px',
        boxShadow: '0px 2px 24px rgba(5, 29, 61, 0.04)',
        p: '16px',
        height: '300px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}
      component="div"
    >
      <Stack spacing={1}>
        <Grid container spacing={1}>
          <Grid item lg={9}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600 }}
              color="#3C83AA"
            >
              {title}
            </Typography>
          </Grid>
        </Grid>
        <Box sx={{ my: theme.spacing(2), height: '190px', overflow: 'auto' }}>
          {objectList.length > 0 ? (
            objectList.map((object) => (
              <ChipSocialMediaObject
                key={
                  object.streamType === 'account' ||
                  object.streamType === 'post_link'
                    ? object.content
                    : object.id
                }
                id={
                  object.streamType === 'account' ||
                  object.streamType === 'post_link'
                    ? object.content
                    : object.id
                }
                name={object.objectName}
                socialMedia={object.socialMedia}
                streamType={object.isHashtag ? 'hashtag' : object.streamType}
                onRemove={onRemove}
                sx={{
                  m: '0 8px 8px 0',
                  cursor: 'pointer'
                }}
              />
            ))
          ) : (
            <Typography variant="subtitle2" color="#757575">
              {information}
            </Typography>
          )}
        </Box>
      </Stack>
    </Box>
  );
};

export default InputCardSocialProfile;
